import { ListItem, styled } from "@mui/material";

export const ListItemNavBar = styled(ListItem)(({ theme }) => ({
  borderRadius: "0.5rem",
  cursor: "pointer",
  "&:hover": {
    background: `rgba(${theme.customColors.backgroundSecondaryHover})`
  },
  "&:focus": {
    background: `rgba(${theme.customColors.backgroundSecondaryHover})`
  }
}));
